export default function (editor, opts = {}) {
  const option = opts;
  const domc = editor.DomComponents;

  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  domc.addType('subscriber-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          resizable: true,
          traits: [
            {
              type: 'webconnect-event',
              label: 'Event',
              name: 'onsubmit',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'subscriber-form') {
            return {
              type: 'subscriber-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
    }),
  });
}
